import { Breakpoints } from 'JBSrc/constants';

export function carouselListWidths() {
	var carouselContainerWidth = $('.carousel .container').outerWidth();
	var windowWidth = $(window).outerWidth();
	var carouselItem = $('.carousel__item');

	if (windowWidth > parseInt(Breakpoints.lg)) {
		carouselItem.css({
			width: carouselContainerWidth / 4 + 'px'
		});
	} else if (windowWidth > parseInt(Breakpoints.md)) {
		carouselItem.css({
			width: carouselContainerWidth / 3 + 'px'
		});
	} else if (windowWidth > parseInt(Breakpoints.sm)) {
		carouselItem.css({
			width: carouselContainerWidth / 2 + 'px'
		});
	} else {
		carouselItem.removeAttr('style');
	}
}

export function carouselBreakpoints(carouselParent) {
	var windowWidth = $(window).outerWidth();
	var hasArrows = true;
	if (windowWidth > parseInt(Breakpoints.lg)) {
		hasArrows = carouselParent.find('.slick-slide:not(.slick-cloned)').length >= 4;
	} else if (windowWidth > parseInt(Breakpoints.md)) {
		hasArrows = carouselParent.find('.slick-slide:not(.slick-cloned)').length >= 3;
	} else if (windowWidth > parseInt(Breakpoints.sm)) {
		hasArrows = carouselParent.find('.slick-slide:not(.slick-cloned)').length >= 2;
	}else{
		hasArrows = carouselParent.find('.slick-slide:not(.slick-cloned)').length >= 1;
	}

	if(hasArrows){
		carouselParent.slick('slickSetOption', 'arrows', true);
		carouselParent.slick('slickSetOption', 'infinite', true);
		carouselParent.slick('slickSetOption', 'swipe', true);
		carouselParent.parent().find('.carousel__btn-previous').show();
		carouselParent.parent().find('.carousel__btn-next').show();
		carouselParent.find('.slick-slide.slick-cloned').show();
	}else{
		carouselParent.slick('slickSetOption', 'arrows', false);
		carouselParent.slick('slickSetOption', 'infinite', false);
		carouselParent.slick('slickSetOption', 'swipe', false);
		carouselParent.parent().find('.carousel__btn-previous').hide();
		carouselParent.parent().find('.carousel__btn-next').hide();
		carouselParent.find('.slick-slide.slick-cloned').hide();
	}
}

export function carouselList() {
	if ($('.carousel__list').length) {
		$(window).resize(function() {
			carouselListWidths();
			$('.carousel__list').each(function() {
				carouselBreakpoints($(this));
			});
		});

		$('.carousel__list').each(function() {
			if (!$(this).hasClass('slick-initialized')) {
				var carouselParent = $(this);

				carouselParent.on('init', function() {
					carouselListWidths();
					setTimeout(function() {
						carouselBreakpoints(carouselParent);
					}, 0);
				});

				var windowWidth = $(window).outerWidth();
				var hasArrows = true;
				if (windowWidth > parseInt(Breakpoints.lg)) {
					hasArrows = carouselParent.find('.carousel__item').length >= 4;
				} else if (windowWidth > parseInt(Breakpoints.md)) {
					hasArrows = carouselParent.find('.carousel__item').length >= 3;
				} else if (windowWidth > parseInt(Breakpoints.sm)) {
					hasArrows = carouselParent.find('.carousel__item').length >= 2;
				}else{
					hasArrows = carouselParent.find('.carousel__item').length >= 1;
				}
				if(hasArrows){
					carouselParent.parent().find('.carousel__btn-previous').show();
					carouselParent.parent().find('.carousel__btn-next').show();
				}else{
					carouselParent.parent().find('.carousel__btn-previous').hide();
					carouselParent.parent().find('.carousel__btn-next').hide();
				}

				carouselParent.slick({
					infinite: true,
					variableWidth: true,
					arrows: true,
					dots: false,
					speed: 200,
					prevArrow: carouselParent.parent().find('.carousel__btn-previous'),
					nextArrow: carouselParent.parent().find('.carousel__btn-next')
				});
			}
		});
	}
}
